import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Button, Dropdown, Form, SplitButton } from "react-bootstrap";
import classNames from "classnames";

export type SearchProps = {
    onSearch: (searchState: SearchState) => void;
    hideContains?: boolean;
    mainSearchClass?: string;
    searchBoxClass?: string;
    totalRows?: number;
    placeholder?: string;
    customSearch?: React.ReactNode;
};

export type SearchState = {
    keyword?: string;
    contains?: boolean;
    searchPdes?: boolean;
    searchBarcodes?: boolean;
}

export interface SearchForwardRef {
    getSearchState: () => SearchState;
    getAppliedSearchState: () => SearchState;
}

const Search = forwardRef<SearchForwardRef | undefined, SearchProps>(({onSearch, mainSearchClass, searchBoxClass, customSearch, totalRows, placeholder, hideContains = false}: SearchProps, ref) => {
    useImperativeHandle(ref, () => ({
        getSearchState() {
            return { keyword: keyword, contains: contains };
        },
        getAppliedSearchState() {
            return appliedSearchState;
        }
    }));

    const [keyword, setKeyword] = useState<string | undefined>();
    const [appliedSearchState, setAppliedSearchState] = useState<SearchState>({});
    const [contains, setContains] = useState<boolean | undefined>(!hideContains ? true : undefined);
    const [displayMenu, setDisplayMenu] = useState(false);
    
    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            event.stopPropagation();
            event.preventDefault();
            handleSubmit({ keyword: keyword, contains: contains});
        }
    };

    const handleSubmit = (state: SearchState) => {
        setAppliedSearchState(state);
        onSearch(state);
    }

    useEffect(() => {
        setAppliedSearchState({keyword: keyword, contains: contains});
    }, []);

    return (
        <>
        <div className={classNames(mainSearchClass, "d-flex main-search search")}>
            <div className={classNames(searchBoxClass, "search-container")}>
                <span className="d-flex align-items-center">
                    <input
                        spellCheck="false"
                        value={keyword ?? ""}
                        onChange={(e) => {
                            if (e.target.value === "") {
                                setKeyword(undefined);
                            } else {
                                setKeyword(e.target.value);
                            }
                        }}
                        onKeyDown={handleKeyPress}
                        placeholder={`Search ${totalRows !== undefined ? totalRows + ' ' : ''}records ${placeholder ?? ""}`}
                        className="form-control w-auto ms-1"
                    />
                </span>
            </div>
            {(customSearch || !hideContains) ?
                <SplitButton
                    variant="primary"
                    title="Search"
                    onClick={() => {
                        handleSubmit({ keyword: keyword, contains: contains })
                    }}
                    className="custom-search-button"
                    show={displayMenu}
                    autoClose="outside"
                    onToggle={() => setDisplayMenu(!displayMenu)}
                >  {!hideContains && 
                        <Dropdown.Item onClick={() => setContains(!contains)}>
                            <Form.Check
                                type="checkbox"
                                label="Contains"
                                id="contains"
                                checked={contains}
                                onChange={(e) => { 
                                    setContains(!contains);
                                }}
                                onClick={e => e.stopPropagation()}
                            /></Dropdown.Item>}{customSearch}</SplitButton>
                :
                <Button 
                    variant="primary" 
                    className="btn-icon custom-btn-icon filter-btn" 
                    onClick={() => handleSubmit({ keyword: keyword, contains: contains })}
                >Search</Button>
            }
        </div>
    </>
    );
});

export { Search };